import React from "react";
import { Card } from "primereact/card";
import { classNames } from "primereact/utils";
import { FieldDisplaySectionProps } from "./types";
import { Divider } from "primereact/divider";

export function FieldDisplay({
  title,
  fields,
  icon,
}: FieldDisplaySectionProps) {
  const header = (
    <div className="flex align-items-center gap-3 mb-2">
      {icon && (
        <div className="flex align-items-center justify-content-center border-round bg-primary-100 text-primary w-3rem h-3rem">
          <i className={classNames("pi", icon, "text-xl")} />
        </div>
      )}
      <h2 className="m-0 text-xl font-bold text-900">{title}</h2>
    </div>
  );

  return (
    <Card
      header={header}
      className="mb-4 shadow-2 border-round-xl mt-1"
      style={{ overflow: "hidden" }}
    >
      <div className="p-fluid">
        {fields.map(({ label, value, status }, idx) => {
          // Determine text color based on status
          let textClass = "text-900 font-semibold";
          if (status === "closed") {
            textClass = "text-red-600 font-bold";
          } else if (status === "open") {
            textClass = "text-green-600 font-bold";
          } else if (status === "24hours") {
            textClass = "text-blue-600 font-bold";
          } else if (status === "incomplete") {
            textClass = "text-orange-600 font-semibold";
          } else if (status === "info") {
            textClass = "text-blue-500 font-semibold";
          }

          // Add status indicator
          let statusIcon = "";
          if (status === "closed") {
            statusIcon = "❌ ";
          } else if (status === "open") {
            statusIcon = "✅ ";
          } else if (status === "24hours") {
            statusIcon = "🔄 ";
          } else if (status === "incomplete") {
            statusIcon = "⚠️ ";
          }

          return (
            <div key={idx}>
              <div className="flex flex-column md:flex-row md:align-items-center md:justify-content-between py-2">
                <div className="text-600 font-medium">{label}</div>
                <div className={textClass}>
                  {value && String(value).trim() !== "" ? (
                    <span>{statusIcon}{value}</span>
                  ) : (
                    <span className="text-500">—</span>
                  )}
                </div>
              </div>
              {idx !== fields.length - 1 && <Divider className="my-1" />}
            </div>
          );
        })}
      </div>
    </Card>
  );
}
